// 部品 ボタン左右中央均等割り用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const RowFullJustifyButton: React.FC = ({ children }) => {
  return (
    <Row className="row-full-justify-button">
      <Col className="text-center">{children}</Col>
    </Row>
  );
};

export default RowFullJustifyButton;
